const capitalizeFirstLetter = (string = '') => {
  return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1)
}

const getDescription = (
  apiKeysNumber,
  apiKeySelected,
  networkSelected,
  subnetName,
  showKeyAndNetwork
): { title: string; description: string } => {
  if (apiKeysNumber === 0) {
    return {
      description: 'Create an API to send your first request.',
      title: `You don't have any API keys yet`
    }
  } else if (apiKeySelected && !networkSelected) {
    return {
      description: 'Select network you want to use for your API key.',
      title: 'What network do you want to use first?'
    }
  } else if (apiKeysNumber > 1 && !apiKeySelected) {
    return {
      description: 'Select an API key from the list below that you wish to send your first request to.',
      title: 'Select an API key'
    }
  } else if (showKeyAndNetwork && subnetName && networkSelected) {
    return {
      description: `Your API key is your passport to the ${capitalizeFirstLetter(
        networkSelected === 'eth' ? 'ethereum' : networkSelected
      )} ${capitalizeFirstLetter(
        subnetName
      )} network.  Always append your API key to your request URL to authenticate your request with MetaMask Developer.`,
      title: 'View your API key'
    }
  }

  return { description: '', title: '' }
}

export default getDescription
